
const config = {
    API_URL: `https://portal-api.wundercoach.net/api/v3`,
};

export default config;
